export default "__VITE_ASSET__Bu0n4w1___"